import type { Project } from "./types"
import type { ProjectMeta } from "./global-sync/types"

export function enrichProject(
  project: { worktree: string; expanded: boolean },
  metadata: Project | undefined,
  local: { projectMeta?: ProjectMeta; icon?: string },
) {
  const base = {
    ...metadata,
    ...(!metadata || metadata.id === "global" ? local.projectMeta : undefined),
    ...(local.projectMeta?.name !== undefined ? { name: local.projectMeta.name } : {}),
    ...project,
  }
  if (local.icon) return { ...base, icon: { ...base.icon, override: local.icon } }
  return base
}
